'use client'

import { Col, Row, Separator, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import type { ProjectsProject } from '@repo/shared/types'
import { type ReactNode } from 'react'
import {
  ConvertDateTimeToDay,
  PaymentType,
  ToDate,
} from '@repo/shared/components'
import { InformationDialog } from '@repo/shared'

export interface ProjectDetailInfoProps {
  project: ProjectsProject
}

type InfoItem = {
  label: string
  info?: string
  valueKey?: string
  valueProps?: Record<string, () => ReactNode | string | number>
  value?: ReactNode
}

export const ProjectDetailInfo = ({ project }: ProjectDetailInfoProps) => {
  const { t, tRich } = useTranslate()

  const formatNumber = (num: number) => {
    return num.toLocaleString()
  }

  const renderValue = (item: InfoItem) => {
    if (item.valueKey) {
      return tRich.rich(item.valueKey, item.valueProps)
    }
    return item.value
  }

  const Bold = ({ children }: { children: ReactNode }) => {
    return (
      <Typography size='md' color='text-neutral-surface-100' weight='bold'>
        {children}
      </Typography>
    )
  }

  const infoItems: InfoItem[] = [
    // {
    //   label: t('projectsDetail_info_propertyArea'),
    //   valueKey: 'projectsDetail_info_squareMeter',
    //   valueProps: {
    //     value: () => (
    //       <Bold>{formatNumber((project?.market?.maxSupply || 0) / 10000)}</Bold>
    //     ),
    //   },
    // },
    // {
    //   label: t('projectsDetail_info_offered'),
    //   info: t('info_min_purchase'),
    //   valueKey: 'projectsDetail_info_tokensEqualsArea',
    //   valueProps: {
    //     tokens: () => formatNumber(project?.market?.totalSupply || 0),
    //     area: () => (
    //       <Bold>
    //         {formatNumber((project?.market?.totalSupply || 0) / 10000)}
    //       </Bold>
    //     ),
    //   },
    // },
    // {
    //   label: t('projectsDetail_info_offerDate'),
    //   ...(project?.market?.releaseDate && {
    //     valueKey: 'projectsDetail_info_offerDate_last_day',
    //   }),
    //   ...(project?.market?.releaseDate
    //     ? {
    //         valueProps: {
    //           day: () =>
    //             project?.market?.releaseDate ? (
    //               <span className='text-2xs text-neutral-surface-60'>
    //                 <ConvertDateTimeToDay time={project?.market?.releaseDate} />
    //               </span>
    //             ) : (
    //               '--'
    //             ),
    //           date: () => (
    //             <span className='text-sm text-neutral-surface-100'>
    //               {project?.market?.releaseDate ? (
    //                 <ToDate date={new Date(project?.market?.releaseDate)} />
    //               ) : (
    //                 '--'
    //               )}
    //             </span>
    //           ),
    //         },
    //       }
    //     : { value: '--' }),
    // },
    {
      label: t('projectsDetail_info_marketValue'),
      info: t('info_market_value'),
      value: (
        <PaymentType
          value={project?.price?.marketCap}
          inputCurrency='IRR'
          outputCurrency='TMN'
          isBold
          numberSize='md'
        />
      ),
    },
    // {
    //   label: t('projectsDetail_info_soldCirculation'),
    //   info: t('info_sold_circulation'),
    //   valueKey: 'projectsDetail_info_tokensEqualsSmallArea',
    //   valueProps: {
    //     tokens: () =>
    //       formatNumber(
    //         project?.circulation?.otcCirculating || 0 / (project?.scale || 1),
    //       ),
    //     area: () => (
    //       <Bold>
    //         {formatNumber((project?.circulation?.otcCirculating || 0) / 10000)}
    //       </Bold>
    //     ),
    //   },
    // },
    {
      label: t('projectsDetail_info_minPurchase'),
      valueKey: 'projectsDetail_info_purchaseTokens',
      valueProps: {
        min: () => formatNumber(project?.market?.minOrderSize || 0),
        max: () =>
          formatNumber(
            (Number(project?.market?.minOrderSize || 0) *
              (project?.pricePerMeter || 0)) /
              10,
          ),
      },
    },
  ]

  return (
    <Col className='gap-md py-0 sm:py-4'>
      {infoItems.map((item, index) => (
        <div key={index}>
          <Row className='justify-between items-center'>
            <Row className='items-center gap-xs'>
              <Typography size='xs' color='text-neutral-surface-80'>
                {item.label}
              </Typography>
              {item.info && (
                <InformationDialog title={item.label}>
                  {item.info}
                </InformationDialog>
              )}
            </Row>
            <Typography
              size='2xs'
              color='text-neutral-surface-80'
              className='whitespace-nowrap'
            >
              {renderValue(item)}
            </Typography>
          </Row>
          {(index === 0 || index === 3) && <Separator className='mt-md' />}
        </div>
      ))}
    </Col>
  )
}
